<template>
  <div class="ion-page">
    <ion-header>
      <ion-toolbar color="navbar">
        <ion-buttons slot="start">
          <ion-button @click="closeModel">Close</ion-button>
        </ion-buttons>
        <ion-title>Upgrade</ion-title>
      </ion-toolbar>
    </ion-header>
    <ion-content padding>
      <ion-card color="light">
        <ion-card-header>
          <ion-card-title>Upgrade Your Account</ion-card-title>
          <ion-card-subtitle>The free plan only allows you to create one form, upgrading lets you create as many forms as you need. Just imagine the possibilities!</ion-card-subtitle>
        </ion-card-header>
        <ion-card-content>
          <p>4000001240000000</p>
          <div ref="card"></div>
        </ion-card-content>
        <ion-card-content>
          <ion-button color="primary" expand="block" fill="outline" @click="confirmPurchase">Confirm Purchase</ion-button>
        </ion-card-content>
      </ion-card>
    </ion-content>
  </div>
</template>

<script>
import Helpers from "../mixins/Helpers";
import router from "../router";
import store from "../store";
export default {
  store: store,
  router: router,
  name: "user-upgrade",
  mixins: [Helpers],
  props: ["form"],
  data() {
    return {
      stripe: null,
      card: null
    };
  },
  computed: {
    user() {
      return this.$store.getters.getUser();
    }
  },
  mounted() {
    let style = {
      base: {
        border: "1px solid #D8D8D8",
        borderRadius: "4px",
        color: "#000"
      },
      invalid: {}
    };
    this.stripe = Stripe(process.env.VUE_APP_STRIPE_PUBLISH_TEST);
    this.card = this.stripe.elements().create("card");
    this.card.mount(this.$refs.card, {
      style: style,
      hidePostalCode: true
    });
  },
  methods: {
    closeModel() {
      this.hideModal();
    },
    async confirmPurchase() {
      let loading = await this.showLoading("Upgrading...");
      try {
        let stripe = await this.stripe.createToken(this.card);
        if (stripe.error) {
          this.$forceUpdate();
          this.showWarning(stripe.error);
        } else if (stripe.token) {
          await this.$store.dispatch("userUpgrade", {
            token: stripe.token.id,
            amount: 499,
            currency: "cad",
            test: true
          });
          this.showAlert("Upgrade Successful", "Thanks for upgrading, now you're cookin' with rocket fuel!", [
            {
              text: "OK",
              role: "cancel",
              handler: async (data) => {
                await this.hideModal();
                await this.closeMenu();
              }
            }
          ]);
        } else {
          this.showWarning("There was a problem loading credit card information");
        }
      } catch (error) {
        this.$forceUpdate();
        this.showWarning(error);
      } finally {
        loading.dismiss();
      }
    }
  }
};
</script>

<style scoped>
.StripeElement {
  background-color: white;
  padding: 8px 12px;
  border-radius: 4px;
  border: 1px solid transparent;
  box-shadow: 0 1px 3px 0 #e6ebf1;
  -webkit-transition: box-shadow 150ms ease;
  transition: box-shadow 150ms ease;
}
.StripeElement--focus {
  box-shadow: 0 1px 3px 0 #cfd7df;
}
.StripeElement--invalid {
  border-color: #fa755a;
}
.StripeElement--webkit-autofill {
  background-color: #fefde5 !important;
}
</style>